/**
 * Data Layer push on next page load
 */

// Imports
import {
  readCookie,
  writeCookie,
  eraseCookieNoRefresh,
} from './tools/Cookie';
import {
  stripHTML
} from './Utils';
import {
  addToDataLayer,
} from './DataLayer';
import {
siteReadyEventName,
} from './Events';

const cookieName = 'DLPushOnLoad';
const localStorageName = 'LSPushOnLoad';

function clearData() {
  eraseCookieNoRefresh(cookieName);

  if (localStorage.getItem(localStorageName)) {
    localStorage.removeItem(localStorageName);
  }
}

function getData() {
  const dataString = readCookie(cookieName) || localStorage.getItem(localStorageName) || false;

  clearData();

  if (dataString) {
    const data = JSON.parse(dataString);
    if (typeof data === 'object') {
      return data;
    }
  }

  return null;
}

function createPushOnLink(data) {
  let dataString;
  let existingPushDatas = getData() || [];

  switch (typeof data) {
    case 'object': {
      dataString = JSON.parse(stripHTML(JSON.stringify(data)));
      existingPushDatas.push(dataString);
      break;
    }
    default: {
      existingPushDatas = data;
    }
  }

  if (dataString.products) {
    return localStorage.setItem(localStorageName, JSON.stringify(existingPushDatas));
  }

  return writeCookie(cookieName, existingPushDatas);
}

function init() {
  const cookieDatas = getData();

  if (cookieDatas === null) {
    return false;
  }

  $(document).on(siteReadyEventName, () => {
    for (let i = 0; i < cookieDatas.length; i += 1) {
      addToDataLayer(cookieDatas[i]);
    }
  });

  return true;
}

function initAsync() {
  const cookieDatas = getData();

  if (cookieDatas === null) {
    return false;
  }

  for (let i = 0; i < cookieDatas.length; i += 1) {
    addToDataLayer(cookieDatas[i]);
  }

  return true;
}

export {
  getData,
  clearData,
  createPushOnLink,
  init,
  initAsync
};

export default init;



// WEBPACK FOOTER //
// ./js/common/DataLayerNextPage.js